import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { updateUser } from '../actions'
import { Field, reduxForm, submit } from 'redux-form';
import { Form, Icon, Input, Button, Checkbox, Switch, Alert } from 'antd';
import Card, { TitleCard, CardHeader } from '../../core/Card'
import normalizePhone from '../../core/normalizePhone'
import makeField from './makeField'
import './Profile.css'


const email = value =>
  value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(value)
    ? 'Invalid email address'
    : undefined

export const minLength = min => value =>
  value && value.length < min ? `Too short, use at least ${min} characters` : undefined


const AInput = makeField(Input);
const ASwitch = makeField(Switch);

export const PersonalInfo = ({handleSubmit, submitPersonalInfoForm, pristine, invalid, submitting, submitSucceeded, error, reset}) =>
  <Card>
    <CardHeader
      title="Personal Info"
      buttonOnClick={handleSubmit}
      buttonDisabled={pristine}
      buttonTitle="Save"
      buttonLoading={submitting}
      buttonClassName="ant-btn-primary"
    />

    <Field
      name="name"
      type="text"
      component={AInput}
      label="First Name"
      hasFeedback
    />
    <Field
      name="last"
      type="text"
      component={AInput}
      label="Last Name"
      hasFeedback
    />
    <Field
      name="email"
      type="text"
      component={AInput}
      label="E-mail"
      hasFeedback
      validate={email}
    />

    <Field
      name="mobile"
      type="text"
      component={AInput}
      label="Mobile"
      normalize={normalizePhone}
    />

    <Field
      name="kms_enabled"
      type="checkbox"
      component={ASwitch}
      label="Use Kilometres"
    />

    <Field
      name="custom_mileage_rate"
      type="number"
      component={AInput}
      label="Rate Per Work Mile"
    />

    { submitSucceeded ? <Alert message="User has been updated." type="success" /> : null}
    { error && <Alert message={error} type="error" />}

  </Card>

const mapStateToProps = (state, ownProps) => {
  const {user} = state.models

  return {
    initialValues: {
      name: user.name,
      last: user.last,
      email: user.email,
      mobile: user.mobile,
      kms_enabled: user.kms_enabled,
      custom_mileage_rate: user.custom_mileage_rate || user.work_mileage_rate,
    },
    enableReinitialize: true,
  }
}

export default connect( mapStateToProps )(
  reduxForm({
    form: 'personalInfo',
    onSubmit: (values, dispatch)=> dispatch(updateUser(values)),
  })(PersonalInfo)
)



// WEBPACK FOOTER //
// ./src/account/profile/PersonalInfo.jsx